// import { Dayjs } from "dayjs";

// Enums para os valores fixos
export enum UserProfile {
  Usuário = "Usuário",
  Promoter = "Promotor",
  Administrador = "Administrador",
  Employee = "Funcionário",
  Mentoria = "Mentoria",
  Diretoria = "Diretoria",
}

interface EnderecoEntrega extends Endereco {
  enderecoId: string;
  logradouroNumero?: string;
  codigoMunicipio?: string;
  enderecoPadrao?: boolean;
  entregaIE?: string;
}

export interface IUser {
  ID?: string;
  UltimaAlteracao?: string | Date; // Pode ser usado como Date após parsing
  DataCadastro?: string | Date;
  PessoaFisica?: boolean;
  NomeFantasia?: string;
  RazaoSocial?: string;
  CNPJ_CPF?: string;
  Rg?: string;
  Ie?: string;
  Logradouro?: string;
  LogradouroNumero?: string;
  complemento?: string;
  Bairro?: string;
  Cidade?: string;
  CodigoMunicipio?: string;
  Pais?: string;
  CodigoPais?: string;
  CEP?: string;
  Uf?: string;
  CodigoUF?: string;
  Telefone?: string;
  Celular?: string;
  Email?: string;
  Site?: string;
  Cliente?: boolean;
  Tecnico?: boolean;
  Vendedor?: boolean;
  Transportadora?: boolean;
  Fonecedor?: boolean; // Nota: Possível typo, deveria ser "fornecedor"?
  Representada?: boolean;
  Ramo?: string;
  vendedorPadrao?: string;
  EmailLoginEcommerce?: string;
  Senha?: string;
  Salt?: string;
  Bloqueado: boolean;
  NomePai?: string;
  NomeMae?: string;
  Naturalidade?: string;
  ValorMinimoCompra?: number;
  DataNascimento?: string | Date;
  EstaInadimplente?: boolean;
  EnderecoCobranca?: Endereco;
  EnderecoPadrao?: Endereco;
  EnderecosEntrega?: EnderecoEntrega[];
  EmailsSecundarios?: string[];
  TelefonesSecundarios?: string[];
}

interface atributos {
  Nome: string;
  Model: string;
}

interface IPetsBase {
  _id?: string;
  id?: string;
  name: string;
  gender?: string;
  breed?: string;
  age?: number | string;
  foto?: string;
  photo?: string;
  weight?: number | string;
  species?: string;
  isDeceased?: boolean;
  deathDate?: string | Date;
  dateOfBirth?: string | Date;
  dateOfPurchase?: string | Date;
  color?: string;
}

export interface IPetForBackend extends IPetsBase {
  tutor: string | undefined; // ID do tutor (ObjectId)
  tutorData?: IUser; // Dados completos do tutor para sincronização (opcional)
}

export interface IPetPopulated extends IPetsBase {
  tutor: {
    // Campos MongoDB (legacy)
    _id?: string;
    idERP?: string;
    telefone?: string;
    telefonesSecundarios?: string;
    celular?: string;
    logradouro?: string;
    bairro?: string;
    cep?: string;
    logradouroNumero?: string;

    // Campos PostgreSQL (atual)
    id?: string;
    erpId?: string;
    phone?: string;
    secondaryPhone?: string;
    mobile?: string;
    addressStreet?: string;
    addressDistrict?: string;
    addressZip?: string;
    addressNumber?: string;
    addressCity?: string;
    addressState?: string;

    // Campos comuns
    name: string;
    cpf: string;
    cidade?: string;
    password?: string;
    email?: string;
    birthDate: string | Date;
    tecnico?: boolean;
    technician?: boolean;
    createdAt: string | Date;
  };
  // Adicionar owner como alternativa ao tutor (para compatibilidade com diferentes endpoints)
  owner?: {
    id?: string;
    mongoId?: string | null;
    erpId?: string;
    name: string;
    cpf: string;
    email?: string;
    phone?: string;
    secondaryPhone?: string;
    mobile?: string;
    birthDate?: string | Date;
    addressStreet?: string;
    addressNumber?: string;
    addressDistrict?: string;
    addressCity?: string;
    addressState?: string;
    addressZip?: string;
    technician?: boolean;
    createdAt?: string | Date;
    updatedAt?: string | Date;
  };
}

export type IPets = IPetForBackend | IPetPopulated;

interface Endereco {
  Exterior?: boolean;
  CEP?: string;
  Logradouro?: string;
  Uf?: string;
  CodigoUF?: string;
  Cidade?: string;
  Numero?: string;
  Bairro?: string;
  CodigoCidade?: string;
  Pais?: string;
  CodigoPais?: string;
}

interface AtributoItem {
  atributoId: string;
  descricao: string;
  abreviacao: string;
  valor: string;
}

interface AtributoPedido {
  Nome: string;
  Model: string;
}

interface ComposicaoItem {
  produto: string;
  deposito: string;
  consumo: number;
  consumoTotal: number;
  numerosSerie: string;
}

interface ItemVenda {
  Codigo: string;
  Unidade: string;
  Descricao: string;
  Quantidade: number;
  ValorUnitario: number;
  ValorFrete: number;
  DescontoUnitario: number;
  ValorTotal: number;
  PesoKG: number;
  Comprimento: number;
  Altura: number;
  Largura: number;
  FreteGratis: boolean;
  ValorUnitarioFrete: number;
  PrazoEntregaFrete: number;
  ComissaoVendedor: number;
  Seguro: number;
  Composicoes: ComposicaoItem[];
  Atributos: AtributoItem[];
  AgrupamentoItensVenda: string;
}

interface Pagamento {
  FormaPagamento: string;
  DescricaoPagamento: string;
  ValorPagamento: number;
  BandeiraCartao: string;
  NumeroTerminal: string;
  DataTransacao: string;
  CredenciadoraCartao: string;
  CredenciadoraCNPJ: string;
  CV_NSU: string;
  TipoIntegracao: string;
  CondicaoPagamento: number;
  Parcelas: number;
  PeriodoParcelas: number;
  Adiantamento: number;
  Quitar: boolean;
}

interface LaudoOrdemServico {
  tecnico: string;
  dataRegistro: string;
  laudoTecnicoGeral: string;
}

interface EquipamentoOrdemServico {
  codigo: string;
  nome: string;
  modelo: string;
  observacoes: string;
  fabricante: string;
}

interface VeiculoOrdemServico {
  modelo: string;
  placa: string;
  numeroSerie: string;
  chassi: string;
}

interface OrdemServico {
  ordemServicoConcluida: boolean;
  ordemServicoCancelada: boolean;
  motivoCancelamento: string;
  problema: string;
  laudo: string;
  dataAbertura: string;
  tecnico: string;
  contrato: string;
  dataVisita: string;
  dataInicioIntervencaoTecnica: string;
  dataFinalIntervencaoTecnica: string;
  laudos: LaudoOrdemServico[];
  equipamentos: EquipamentoOrdemServico[];
  veiculos: VeiculoOrdemServico[];
}

export interface Venda {
  ID: string;
  Codigo: number;
  OrigemVenda: string;
  DepositoID: string;
  Tabela: string;
  TabelaID: string;
  Deposito: string;
  StatusSistema: string;
  Status: string;
  Categoria: string;
  Validade: string;
  Empresa: string;
  EmpresaID: string;
  ClienteID: string;
  Cliente: string;
  PessoaID: string;
  ClienteCNPJ: string;
  ClienteEmail: string;
  Vendedor: string;
  PlanoDeConta: string;
  FormaPagamento: string;
  FormaPagamentoID: string;
  NumeroParcelas: number;
  FreteMeioEnvio: number;
  Transportadora: string;
  FreteFormaEnvio: string;
  DataEnvio: string;
  PrevisaoEntrega: string;
  DataPostagem: string;
  Enviado: boolean;
  ValorFrete: number;
  FreteContaEmitente: boolean;
  CodigoRastreio: string;
  EnderecoOpcional: boolean;
  ValorSeguro: number;
  Descricao: string;
  OutrasDespesas: number;
  TransacaoCartao: string;
  ValorFinal: number;
  Finalizado: boolean;
  Lancado: boolean;
  Municipio: string;
  CodigoMunicipio: string;
  Pais: string;
  CEP: string;
  UF: string;
  UfCodigo: string;
  Bairro: string;
  Logradouro: string;
  LogradouroNumero: string;
  LogradouroComplemento: string;
  Items: ItemVenda[];
  Banco: string;
  Data: string;
  Pagamentos: Pagamento[];
  LancarComissaoVendedor: boolean;
  ValorComissaoVendedor: number;
  NumeroNFe: string;
  DataFaturamento: string;
  ChaveAcessoNFe: string;
  DanfeURL: string;
  UrlSefaz: string;
  OrdemServico: OrdemServico;
  CodigoPedidoCliente: string;
  DataAprovacaoPedido: string;
  GerarBoletos: boolean;
  Atributos: AtributoPedido[];
}

export type Vendas = Venda[];

export interface Services {
  ID: string;
  UltimaAlteracao: string;
  Categoria: string;
  Marca: string;
  Fornecedor: string;
  Codigo: string;
  Ean: string;
  Pratileira: string;
  NumeroSerie: string;
  Nome: string;
  Genero: string;
  EstoqueUnidade: string;
  Especificacao: string;
  PesoKG: number;
  PrecoCusto: number;
  LucroDinheiro: number;
  LucroPercentual: number;
  PrecoVenda: number;
  PrecoMinimoVenda: number;
  // Propriedades para edição de preço
  editedPrice?: number;
  originalPrice?: number;
  EstoqueRisco: number;
  DepositoPadrao: number;
  EstoqueSaldo: number;
  NCM: string;
  GrupoTributario: string;
  CFOPPadrao: string;
  UnidadeComercial: string;
  UnidadeTributavel: string;
  OrigemMercadoria: number;
  CEST: string;
  ProduzidoEscalaNaoRelevante: boolean;
  CodigoBeneficioFiscal: string;
  IPI_SituacaoTributaria: string;
  IPI: number;
  IPI_EnquadramentoLegal: string;
  ProdutoPossuiUcomDiferenteDeUtrib: boolean;
  FatorDeConversaoUnidadeComercialParaTributavel: number;
  EAN_UnidadeTributavel_NFe: string;
  UnidadeTributavel_NFe: string;
  PossuiRastreabilidadeSEFAZ: boolean;
  ProdutoPossuiInfComb: boolean;
  PercentualGLP: number;
  PercentualGLPNacional: number;
  PercentualGLPImportado: number;
  ValorPartidaGLP: number;
  EhArmadeFogo: boolean;
  ArmaTipo: number;
  PossuiInformacoesSTRetidosAnteriormente: boolean;
  Aliquota_Suportada_ConsumidorFinal: number;
  FCPST_BaseCalculo: number;
  FCPST_Percentual: number;
  FCPST_Valor: number;
  Valor_ICMS_Substituto: number;
  Valor_ICMS_ST: number;
  VisivelSite: boolean;
  VisivelVendas: boolean;
  DestaqueSite: boolean;
  IgnorarEstoque: boolean;
  FreteGratis: boolean;
  PercentualDescontoBoleto: number;
  Comprimento: number;
  Altura: number;
  Largura: number;
  Diametro: number;
  TipoDoProduto: number;
  PrecosTabelas: [
    {
      Tabela: string;
      PrecoVenda: string;
    },
  ];
  Categorias: [string];
}

export interface Produtos {
  ID: string;
  UltimaAlteracao: string;
  Categoria: string;
  Marca: string;
  Fornecedor: string;
  Codigo: string;
  Ean: string;
  Pratileira: string;
  NumeroSerie: string;
  Nome: string;
  Genero: string;
  EstoqueUnidade: string;
  Especificacao: string;
  PesoKG: number;
  PrecoCusto: number;
  LucroDinheiro: number;
  LucroPercentual: number;
  PrecoVenda: number;
  PrecoMinimoVenda: number;
  // Propriedades para edição de preço
  editedPrice?: number;
  originalPrice?: number;
  EstoqueRisco: number;
  DepositoPadrao: number;
  EstoqueSaldo: number;
  NCM: string;
  GrupoTributario: string;
  CFOPPadrao: string;
  UnidadeComercial: string;
  UnidadeTributavel: string;
  OrigemMercadoria: number;
  CEST: string;
  ProduzidoEscalaNaoRelevante: boolean;
  CodigoBeneficioFiscal: string;
  IPI_SituacaoTributaria: string;
  IPI: number;
  IPI_EnquadramentoLegal: string;
  ProdutoPossuiUcomDiferenteDeUtrib: boolean;
  FatorDeConversaoUnidadeComercialParaTributavel: number;
  EAN_UnidadeTributavel_NFe: string;
  UnidadeTributavel_NFe: string;
  PossuiRastreabilidadeSEFAZ: boolean;
  ProdutoPossuiInfComb: boolean;
  PercentualGLP: number;
  PercentualGLPNacional: number;
  PercentualGLPImportado: number;
  ValorPartidaGLP: number;
  EhArmadeFogo: boolean;
  ArmaTipo: number;
  PossuiInformacoesSTRetidosAnteriormente: boolean;
  Aliquota_Suportada_ConsumidorFinal: number;
  FCPST_BaseCalculo: number;
  FCPST_Percentual: number;
  FCPST_Valor: number;
  Valor_ICMS_Substituto: number;
  Valor_ICMS_ST: number;
  VisivelSite: boolean;
  VisivelVendas: boolean;
  DestaqueSite: boolean;
  IgnorarEstoque: boolean;
  FreteGratis: boolean;
  PercentualDescontoBoleto: number;
  Comprimento: number;
  Altura: number;
  Largura: number;
  Diametro: number;
  TipoDoProduto: number;
  PrecosTabelas: [
    {
      Tabela: string;
      PrecoVenda: string;
    },
  ];
  Categorias: [string];
}

export interface IItem {
  Codigo: string;
  Unidade: string;
  Descricao: string;
  Quantidade: number;
  ValorUnitario: number;
  ValorFrete: number;
  DescontoUnitario: number;
  ValorTotal: number;
  PesoKG: number;
  Comprimento: number;
  Altura: number;
  Largura: number;
  FreteGratis: boolean;
  ValorUnitarioFrete: number;
  PrazoEntregaFrete: number;
  ComissaoVendedor: number;
  Seguro: number;
  AgrupamentoItensVenda: string;
}

export interface IPedido {
  ID?: string;
  AndroidVendaID?: string;
  Codigo?: number;
  OrigemVenda?: string;
  DepositoID?: string;
  Tabela?: string;
  TabelaID?: string;
  Deposito?: string;
  StatusSistema?: string;
  Status?: string;
  Categoria?: string;
  Validade?: string;
  Empresa?: string;
  EmpresaID?: string;
  ClienteID?: string;
  Cliente: string;
  PessoaID: string;
  ClienteCNPJ: string;
  ClienteEmail: string;
  Vendedor: string;
  PlanoDeConta?: string;
  FormaPagamento?: string;
  FormaPagamentoID?: string;
  NumeroParcelas?: number;
  FreteMeioEnvio?: number;
  Transportadora?: string;
  Pagamentos?: Pagamento[];
  FreteFormaEnvio?: string;
  DataEnvio?: string;
  PrevisaoEntrega?: string;
  DataPostagem?: string;
  Enviado?: boolean;
  ValorFrete?: number;
  FreteContaEmitente?: boolean;
  CodigoRastreio?: string;
  EnderecoOpcional?: boolean;
  ValorSeguro?: number;
  Descricao?: string;
  OutrasDespesas?: number;
  TransacaoCartao?: string;
  ValorFinal?: number;
  Finalizado?: boolean;
  Lancado?: boolean;
  Municipio?: string;
  CodigoMunicipio?: string;
  Pais?: string;
  Cep?: string;
  Uf?: string;
  UfCodigo?: string;
  Bairro?: string;
  Logradouro?: string;
  LogradouroNumero?: string;
  LogradouroComplemento?: string;
  Items: IItem[];
  Banco?: string;
  Data: string;
  LancarComissaoVendedor: boolean;
  ValorComissaoVendedor?: number;
  NumeroNFe?: string;
  DataFaturamento?: string;
  ChaveAcessoNFe?: string;
  DanfeURL?: string;
  UrlSefaz?: string;
  OrdemServico: {
    OrdemServicoConcluida: boolean;
    OrdemServicoCancelada: boolean;
    MotivoCancelamento?: string;
    Problema: string;
    Laudo: string;
    DataAbertura: string;
    Tecnico: string;
    Contrato?: string;
    DataVisita: string;
    DataInicioIntervencaoTecnica: string;
    DataFinalIntervencaoTecnica?: string;
    Laudos: [
      {
        Tecnico: string;
        DataRegistro: string;
        LaudoTecnicoGeral: string;
      },
    ];
  };
  Atributos: [
    {
      Nome: string;
      Model: string;
    },
  ];

  // Campos para lançamento financeiro (opcionais)
  pagamentoQuitado?: boolean;
  valorPago?: number;
  formaPagamento?: string;
  contaBancaria?: string;
  dataVencimento?: string;
}

// Interface para Lançamentos Financeiros
export interface ILancamento {
  codigo?: number;
  dataCompetencia: string;
  dataVencimento: string;
  empresa?: string;
  cliente?: string;
  numeroDocumento?: string;
  descricao?: string;
  observacoes?: string;
  quitado?: boolean;
  dataQuitacao?: string | null;
  conciliado?: boolean;
  ehDespesa: boolean;
  planoDeConta?: string;
  centroDeCusto?: string;
  contaBancaria?: string;
  formaPagamento?: string;
  lancamentoGrupo?: string;
  valor: number;
  totalRecebido?: number;
  pagamentos?: Array<{
    data: string;
    formaPagamento: string;
    numeroDocumento: string;
    contaBancaria: string;
    conciliado: boolean;
    valor: number;
  }>;
  modoParcelamento?: number;
  intervalo?: number;
  diasIntervalo?: number;
  juro?: number;
  jurosCompostos?: boolean;
  numeroParcelas?: number;
  parcelas?: Array<{
    dataVencimento: string;
    documento: string;
    valorParcela: number;
    quitado: boolean;
    dataQuitacao?: string | null;
    totalRecebido?: number;
  }>;
}

// Interface para dados de pagamento nos formulários
export interface IPagamentoDados {
  pagamentoQuitado?: boolean;
  valorPago?: number;
  formaPagamento?: string;
  contaBancaria?: string;
  dataVencimento?: string;
}

// Interface para histórico de atendimentos do PostgreSQL
export interface IHistory {
  id: string; // UUID
  petId: string; // FK para Pet
  occurredAt: Date; // Data do atendimento
  description: string; // Descrição do atendimento
  responsible: string; // Responsável pelo atendimento
  serviceType: string; // Tipo de serviço
  pet: {
    id: string;
    name: string;
    breed?: string;
    owner: {
      id: string;
      name: string;
    };
  }; // Relacionamento com Pet
}

// Interface para Notificações
export interface INotification {
  id: string;
  userId: string;
  petId?: string | null;
  title: string;
  summary: string;
  details?: string | null;
  scheduledDate: string; // ISO string
  scheduledTime: string; // Format: "HH:MM"
  isRead: boolean;
  isActive: boolean;
  // WhatsApp dispatch status
  whatsappSent?: boolean;
  whatsappSentAt?: string | null;
  whatsappError?: string | null;
  createdAt: string;
  updatedAt: string;
  user?: {
    id: string;
    name: string;
    email?: string;
  };
  pet?: {
    id: string;
    name: string;
    tutor: string;
    breed?: string;
    photo?: string;
    owner?: {
      id: string;
      name: string;
      phone?: string;
      secondaryPhone?: string;
      mobile?: string;
    };
  };
}

// Interface para criar nova notificação
export interface ICreateNotification {
  title: string;
  summary: string;
  details?: string;
  scheduledDate: string; // ISO string
  scheduledTime: string; // Format: "HH:MM"
  petId?: string;
}

// Interface para atualizar notificação
export interface IUpdateNotification {
  title?: string;
  summary?: string;
  details?: string;
  scheduledDate?: string;
  scheduledTime?: string;
  isRead?: boolean;
  isActive?: boolean;
  petId?: string;
}

// Interface para resposta paginada de notificações
export interface INotificationResponse {
  success: boolean;
  data: INotification[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// Interface para filtros de notificações
export interface INotificationFilters {
  page?: number;
  limit?: number;
  isRead?: boolean;
  isActive?: boolean;
  startDate?: string;
  endDate?: string;
}

// ==================== SCHEDULE (AGENDAMENTOS) ====================

// Enum para status de agendamento
export enum ScheduleStatus {
  PENDENTE = "PENDENTE",
  CONFIRMADO = "CONFIRMADO",
  EM_ANDAMENTO = "EM_ANDAMENTO",
  CONCLUIDO = "CONCLUIDO",
  CANCELADO = "CANCELADO",
}

// Interface principal para agendamento
export interface ISchedule {
  id: string;
  petId: string;
  pet?: IPetPopulated; // Pet populado com dados do tutor
  serviceName: string;
  serviceExternalId?: string;
  scheduledAt: string | Date;
  status: ScheduleStatus;
  requiresPickup: boolean;
  isRecurring: boolean;
  recurrencePattern?: string;
  notes?: string;
  createdAt: string | Date;
  updatedAt: string | Date;
}

// Interface para criar novo agendamento
export interface ICreateSchedule {
  petId: string;
  serviceName: string;
  serviceExternalId?: string;
  scheduledAt: string | Date;
  status?: ScheduleStatus;
  requiresPickup?: boolean;
  isRecurring?: boolean;
  recurrencePattern?: string;
  notes?: string;
  createNotification?: boolean; // Adicionado para consistência com a API
}

// Interface para atualizar agendamento
export interface IUpdateSchedule {
  petId?: string;
  serviceName?: string;
  serviceExternalId?: string;
  scheduledAt?: string | Date;
  status?: ScheduleStatus;
  requiresPickup?: boolean;
  isRecurring?: boolean;
  recurrencePattern?: string;
  notes?: string;
  createNotification?: boolean; // Adicionado para permitir gerenciamento de notificação na atualização
}

// Interface para filtros de agendamentos
export interface IScheduleFilters {
  petId?: string;
  status?: ScheduleStatus | string;
  startDate?: string;
  endDate?: string;
  requiresPickup?: boolean;
}
